import { UNITS } from '@/constants/index';

const names: Record<number, string> = {
  0: UNITS.STATUS.AVAILABLE.NAME,
  1: UNITS.STATUS.ASSIGNED.NAME,
  2: UNITS.STATUS.EN_ROUTE.NAME,
  3: UNITS.STATUS.AT_SCENE.NAME,
  4: UNITS.STATUS.TRANSPORTING.NAME,
  5: UNITS.STATUS.AT_DESTINATION.NAME,
  6: UNITS.STATUS.PARTIALLY_AVAILABLE.NAME,
  7: UNITS.STATUS.COMPLETED.NAME,
  8: UNITS.STATUS.PRE_ASSIGNED.NAME,
  20: UNITS.STATUS.EN_ROUTE_TO_POST.NAME,
  21: UNITS.STATUS.AT_POST.NAME,
  22: UNITS.STATUS.SPECIAL_STATUS.NAME,
  800: UNITS.STATUS.WEATHER_CHECK.NAME,
};

export const statusNames = (code: number) => names[code] || UNITS.STATUS.UNKNOWN.NAME;
